var map = {
	"./account.svg": 1006,
	"./airplane.svg": 8434,
	"./all-season.svg": 6446,
	"./amazon.svg": 6786,
	"./anti-allergy.svg": 900,
	"./argos.svg": 7599,
	"./arrow-left.svg": 6235,
	"./arrow-right.svg": 7587,
	"./article.svg": 8424,
	"./basket-plus.svg": 4700,
	"./basket.svg": 5772,
	"./burger.svg": 4067,
	"./calendar-dates.svg": 2485,
	"./calendar.svg": 617,
	"./chevron-down.svg": 6341,
	"./chevron-left.svg": 5147,
	"./chevron-right-alt.svg": 6802,
	"./chevron-right.svg": 3950,
	"./circle.svg": 2137,
	"./close.svg": 4899,
	"./code-brackets.svg": 5234,
	"./colors.svg": 2714,
	"./comments.svg": 1385,
	"./costco.svg": 7939,
	"./curved-arrow-1.svg": 3941,
	"./curved-arrow-2.svg": 3984,
	"./delivery.svg": 7728,
	"./direction.svg": 2499,
	"./dreams.svg": 9207,
	"./dunelm.svg": 9901,
	"./facebook.svg": 7107,
	"./firm.svg": 9654,
	"./flow.svg": 5718,
	"./grid.svg": 7292,
	"./heart-hands.svg": 7493,
	"./heart.svg": 1059,
	"./instagram-color.svg": 3192,
	"./instagram.svg": 5281,
	"./john-lewis.svg": 64,
	"./klarna.svg": 5954,
	"./linkedin.svg": 9810,
	"./location-pin.svg": 1353,
	"./location.svg": 222,
	"./mail-outline.svg": 8339,
	"./mail.svg": 4247,
	"./map-pin.svg": 8454,
	"./mastercard.svg": 103,
	"./next.svg": 4373,
	"./notepad.svg": 58,
	"./one-hundred-percent-smile.svg": 5078,
	"./payment.svg": 2430,
	"./paypal.svg": 5911,
	"./phone.svg": 825,
	"./pinterest.svg": 3611,
	"./play-icon.svg": 4783,
	"./plugin.svg": 4918,
	"./plus.svg": 2898,
	"./podcast.svg": 4305,
	"./repo.svg": 4453,
	"./search.svg": 8404,
	"./share.svg": 1767,
	"./silentnight.svg": 6004,
	"./slatted.svg": 5698,
	"./splitit.svg": 1496,
	"./spring.svg": 833,
	"./stackalt.svg": 7177,
	"./star.svg": 4317,
	"./textile.svg": 9616,
	"./tick.svg": 9807,
	"./trophy.svg": 9380,
	"./twitter.svg": 1253,
	"./very.svg": 5670,
	"./video.svg": 2799,
	"./visa.svg": 8858,
	"./warranty.svg": 1343,
	"./wayfair.svg": 662,
	"./whatsapp.svg": 5904,
	"./wishlist.svg": 3561,
	"./wood.svg": 2850,
	"./world-leaf.svg": 7504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;